/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.

==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

var hasCartChanged = true;


/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  //Do not throw 'cannot update empty cart' error.
  //It results only from clicking the '-' sign too much
  if (!!data.message && data.message != 'cannot update empty cart') {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $(form).removeClass('is-updating');
      $(document).trigger('ajaxCart.errorAddItem');
    }
  };
  jQuery.ajax(params);
      setTimeout(function(){
      window.cartData();
    },1500);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var $cartContainer = $('#CartContainer');
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    cache: false,
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
      $cartContainer.removeClass('is-updating');
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/

var ajaxCart = (function (module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body, previousCart, cartJsonResponse;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback,
  itemErrorCallback, cartUpdateCallback, buildCart, cartCallback,
  adjustCart, adjustCartCallback, createQtySelectors, qtySelectors,
  validateQty, cartUpsellSlider, carUpsellHandle, getIsCartSumCondition,
  getIsCartNumberItemsCondition, getIsSpecificProductCondition, getIsSpecificCollectionCondition,
  getIsProductTagsCondition;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector: '.product-form',
      cartContainer: '.cart-container',
      addToCartSelector: '.product-form__cart-submit',
      cartCountSelector: '.cart-link__item-count',
      cartCostSelector: null,
      moneyFormat: '$',
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);
    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart =     $(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {

      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    formOverride();

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    cartUpsellSlider();
    carUpsellHandle();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  /*
  updateCountPrice = function (cart) {
      $('').each(function() {
        $(this).html();
      });
    };

  */

  formOverride = function () {
    $('.product-form').on('submit', function (evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');
      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, isOpenDrawerCart = true) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(cartUpdateCallback);
    setTimeout(function(){
      window.cartData();
    },400);

    if (isOpenDrawerCart) {
      setTimeout(function(){
        window.cartData();
        $('#cartDrawer').attr('data-drawer-state', 'open').parent().addClass('drawer-overlay');
        $('#toggleCartDrawer').attr('data-drawer-state', 'open');
        cartUpsellSlider();
        carUpsellHandle();
      },1000)
    }
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $('.variants-wrapper').after('<div class="errors qty-error">' + data.description + '</div>')
      }
    }
    cartUpsellSlider();
    carUpsellHandle();
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    //updateCountPrice(cart);
    setTimeout(function(){
      window.cartData();
    },600);
    setTimeout(function(){
      buildCart(cart);
    },600);
    updateNav(cart.item_count);
  };

  buildCart = function (cart) {
    let previousJson = JSON.stringify(previousCart);
    let currentJson = JSON.stringify(cart);

    if (previousJson == currentJson) return;
    previousCart = cart;
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="cart-empty-text">' + "Your cart is currently empty." + '</p>');
    cartCallback(cart);
    return;
  }

  // Handlebars.js cart layout
  var items = [],
    item = {},
    data = {},
    source = $("#CartTemplate").html(),
    template = Handlebars.compile(source);
    setTimeout(function(){
      window.cartData();
    },600);


    var comparePrice = null;
  // Add each item to our handlebars.js data
  $.each(cart.items, function (index, cartItem) {
    /* Hack to get product image thumbnail
     *   - If image is not null
     *     - Remove file extension, add _small, and re-add extension
     *     - Create server relative link
     *   - A hard-coded url of no-image
    */
    if (cartItem.image != null) {
      var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
    } else {
      var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
    }

    var comparePrice = 0;
    // Create item's data object and add to 'items' array
    window.cartData();
    if(window.tokens) {
      $.each(window.tokens.items, function (index, jsonItem) {
        if(jsonItem.id == cartItem.variant_id) {
          if(jsonItem.compare_at_price > jsonItem.original_price) {
            comparePrice = slate.Currency.formatMoney(jsonItem.compare_at_price, settings.moneyFormat);
          }
          else {
            comparePrice = null;
          }
        }
      })
    }
    
    item = {
      id: cartItem.variant_id,
      line: index + 1, // Shopify uses a 1+ index in the API
      url: cartItem.url,
      img: prodImg,
      name: cartItem.product_title,
      variation: cartItem.variant_title,
      properties: cartItem.properties,
      itemAdd: cartItem.quantity + 1,
      itemMinus: cartItem.quantity - 1,
      itemQty: cartItem.quantity,
      price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
      vendor: cartItem.vendor,
      comparePrice: comparePrice,
      lineItemTotal: slate.Currency.formatMoney(cartItem.final_line_price, settings.moneyFormat)
    };

    items.push(item);
  });

  // Gather all cart data and add to DOM
  data = {
    items: items,
    note: cart.note,
    originalTotalPrice: slate.Currency.formatMoney(cart.original_total_price, settings.moneyFormat),
    totalDiscount: slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat),
    totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
    discounts: cart.cart_level_discount_applications.map(discount => ({
      title: discount.title,
      totalAllocatedAmount: slate.Currency.formatMoney(discount.total_allocated_amount, settings.moneyFormat)
    }))
  }

  $cartContainer.append(template(data));
  $cartContainer.find('select').each((idx, elm) => {
    $(elm).attr('id', `select-cart-upsell-${idx}`);
  });
  cartCallback(cart);
  updateShippingMessage(cart);

  setTimeout(function() {
    $('.js-product-upsell-add-cart').on('click', function(e) {
      $cartContainer.addClass('is-updating');
      const $elm = $(e.currentTarget);
      const productId = $elm.parents('.product-upsell-card__content').find(':selected').val();
      const dataItem = {
        items: [
          {
            quantity: 1,
            id: productId
          }
        ]
      };

      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: dataItem,
        dataType: 'json',
        success: function (line_item) {
          if ((typeof itemAddedCallback) === 'function') {
            itemAddedCallback(line_item, false);
          }
          else {
            ShopifyAPI.onItemAdded(line_item);
          }
          cartUpsellSlider();
          carUpsellHandle();
        },
        error: function (XMLHttpRequest, textStatus) {
          if ((typeof itemErrorCallback) === 'function') {
            itemErrorCallback(XMLHttpRequest, textStatus);
          }
          else {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
          $(document).trigger('ajaxCart.errorAddItem');
          $cartContainer.removeClass('is-updating');
          cartUpsellSlider();
          carUpsellHandle();
        }
      };

      jQuery.ajax(params);
      setTimeout(function(){
        window.cartData();
        $cartContainer.removeClass('is-updating');
      }, 1500);
    });
  }, 1600);
};

cartUpsellSlider = function() {
  setTimeout(function() {
    const $cartUpSellSlider = $('.cart-upsell .slick-slider');

    $cartUpSellSlider.length && $cartUpSellSlider.each(function(_, elm) {
      let slidesToShow = 2;
      const $elm = $(elm);

      if ($elm.length) {
        if ($elm.parents('#cartDrawer').length > 0) {
          slidesToShow = 1;
        }

        $elm.slick({
          infinite: true,
          dots: true,
          arrows: true,
          slidesToShow,
          prevArrow: '<div class="slick-prev"><svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/200svg"><path d="M1.70857e-07 7.93245L7 -4.9534e-08L8 0L8 1.13321L2 7.93245L8 14.7317L8 15.8649L7 15.8649L1.70857e-07 7.93245Z" fill="#777777"/></svg></div>',
          nextArrow: '<div class="slick-next"><svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 8.06757L1 16L0 16L-4.37114e-08 14.8668L6 8.06757L-5.68248e-07 1.26834L-6.11959e-07 0.135133L0.999999 0.135133L8 8.06757Z" fill="#777777"/></svg></div>',
          responsive: [
            {
              breakpoint: 640,
              settings: {
                arrows: false,
                slidesToShow: 1
              }
            }
          ]
        });
      }
    });
  }, 1600)
};

getIsCartSumCondition = function($carUpsell) {
  const dataCart = window.tokens;
  const totalPrice = dataCart.original_total_price;
  const cartSumCompareValue = parseInt($carUpsell.data('cart-sum-compare-value'));
  const cartSumCondition = $carUpsell.data('cart-sum-condition');

  if (cartSumCompareValue) {
    switch (cartSumCondition) {
      case 'is_less_than':
        return totalPrice < cartSumCompareValue;
      case 'is_greater_than':
        return totalPrice > cartSumCompareValue;
      default: // 'equal'
        return totalPrice === cartSumCompareValue;
    };
  }
};

getIsCartNumberItemsCondition = function($carUpsell) {
  const dataCart = window.tokens;
  const cartNumberItemsCompareValue = parseInt($carUpsell.data('cart-number-items-compare-value'));
  const totalNumberItems = dataCart.item_count;
  const cartNumberItemsCondition = $carUpsell.data('cart-number-items-condition');

  if (cartNumberItemsCompareValue) {
    switch (cartNumberItemsCondition) {
      case 'is_less_than':
        return totalNumberItems < cartNumberItemsCompareValue;
      case 'is_greater_than':
        return totalNumberItems > cartNumberItemsCompareValue;
      default: // 'equal'
        return totalNumberItems === cartNumberItemsCompareValue;
    };
  }
}

// A SPECIFIC PRODUCT RULE
getIsSpecificProductCondition = function($carUpsell) {
  const dataCart = window.tokens;
  const specificProductHandle = $carUpsell.data('specific-product');
  const specificProductCondition = $carUpsell.data('specific-product-condition');
  const cartItemsArr = dataCart.items;

  if (specificProductHandle) {
    const cartItemHandles = cartItemsArr.map(item => item.handle);

    switch (specificProductCondition) {
      case 'in_cart':
        return cartItemHandles.includes(specificProductHandle);
      case 'not_in_cart':
        return !(cartItemHandles.includes(specificProductHandle));
      default: // 'only_in_cart'
        for (let idx = 0; idx < cartItemsArr.length; idx++) {
          const item = cartItemsArr[idx];
          if (item.handle !== specificProductHandle) {
            return false;
          }
        }
        return true;
    };
  }
};

// A SPECIFIC COLLECTION RULE
getIsSpecificCollectionCondition = function($carUpsell) {
  const dataCart = window.tokens;
  const productHandles = $carUpsell.data('specific-collection-product-handles') && $carUpsell.data('specific-collection-product-handles').split(',');
  const specificCollectionCondition = $carUpsell.data('specific-collection-condition');
  const cartItemsArr = dataCart.items;

  if (productHandles.length) {
    const cartItemHandles = cartItemsArr.map(item => item.handle);

    switch (specificCollectionCondition) {
      case 'some_items_in_cart':
        const found = productHandles.some(r=> cartItemHandles.includes(r));
        return found;
      case 'all_items_in_cart':
        return productHandles.sort().join(',') === cartItemHandles.sort().join(',');
      default: // 'no_item_in_cart'
        const intersection = cartItemHandles.filter(element => productHandles.includes(element));
        return !(intersection.length);
    };
  }
};

// PRODUCT TAGS RULE
getIsProductTagsCondition = function($carUpsell) {
  const dataCart = window.tokens;
  const productHandles = $carUpsell.data('product-tags-product-handles') && $carUpsell.data('product-tags-product-handles').split(',');
  const productTagsCondition = $carUpsell.data('product-tags-condition');
  const cartItemsArr = dataCart.items;

  if (productHandles.length) {
    const cartItemHandles = cartItemsArr.map(item => item.handle);

    switch (productTagsCondition) {
      case 'some_items_in_cart':
        const found = productHandles.some(r=> cartItemHandles.includes(r));
        return found;
      case 'all_items_in_cart':
        return productHandles.sort().join(',') === cartItemHandles.sort().join(',');
      default: // 'no_item_in_cart'
        const intersection = cartItemHandles.filter(element => productHandles.includes(element));
        return !(intersection.length);
    };
  }
};

carUpsellHandle = function() {
  setTimeout(function() {
    const $carUpsell = $('.cart-upsell');
    $carUpsell.each((_, elm) => {
      const $elm = $(elm);
      const mustMatch = $elm.data('must-match');
      const conditionArr = [getIsCartSumCondition($elm), getIsCartNumberItemsCondition($elm), getIsSpecificProductCondition($elm), getIsSpecificCollectionCondition($elm), getIsProductTagsCondition($elm)];
      const falseConditionArr = conditionArr.filter(c => c == false);
      const trueConditionArr = conditionArr.filter(c => c == true);

      if ($elm.length) {
        if (mustMatch === 'all_conditions') {
          if (falseConditionArr.length) {
            $elm.removeClass('cart-upsell-show');
          } else {
            $elm.addClass('cart-upsell-show');
          }
        }
        else { // mustMatch === 'any_condition'
          if (trueConditionArr.length) {
            $elm.addClass('cart-upsell-show');
          } else {
            $elm.removeClass('cart-upsell-show');
          }
        }
      }
    });
  }, 1600);
};

cartCallback = function (cart) {
  $body.removeClass('drawer--is-loading');
  $body.trigger('ajaxCart.afterCartLoad', cart);
  $cartContainer.removeClass('is-updating');

  if (window.Shopify && Shopify.StorefrontExpressButtons) {
    Shopify.StorefrontExpressButtons.initialize();
  }
};

adjustCart = function () {
  // Delegate all events because elements reload with the cart
  // Reset all events
  $cartContainer.off('click', '.js-qty__adjust');
  $cartContainer.off('change', '.js-qty__num');
  $cartContainer.off('submit', 'form.ajaxcart');
  $cartContainer.off('focus', '.js-qty__adjust');
  $cartContainer.off('click', '.cart-drawer-item__remove');
  $cartContainer.on('click', '.cart-drawer-item__remove', removeItem);

  // Add or remove from the quantity
  $cartContainer.on('click', '.js-qty__adjust', function () {

    var $el = $(this),
      line = $el.data('line'),
      $qtySelector = $el.siblings('.js-qty__num'),
      qty = parseInt($qtySelector.val().replace(/\D/g, ''));

    var qty = validateQty(qty);

    // Add or subtract from the current quantity
    if ($el.hasClass('js-qty__adjust--plus')) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }

    // If it has a data-line, update the cart.
    // Otherwise, just update the input's number
    if (line) {
      updateQuantity(line, qty);
    } else {
      $qtySelector.val(qty);
    }

    cartUpsellSlider();
    carUpsellHandle();
  });

  // Update quantity based on input on change

  $cartContainer.on('change', '.js-qty__num', function () {
    var $el = $(this),
      line = $el.data('line'),
      qty = parseInt($el.val().replace(/\D/g, ''));

    var qty = validateQty(qty);

    // If it has a data-line, update the cart
    if (line) {
      updateQuantity(line, qty);
      cartUpsellSlider();
      carUpsellHandle();
    }
  });

  // Prevent cart from being submitted while quantities are changing

  $cartContainer.on('submit', 'form.ajaxcart', function (evt) {
    if (isUpdating) {
      evt.preventDefault();
    }
    setTimeout(function(){
      window.cartData();
    },600);
  });

  // Highlight the text when focused
  $cartContainer.on('focus', '.js-qty__adjust', function () {
    var $el = $(this);
    setTimeout(function () {
      $el.select();
    }, 50);
  });

  function removeItem() {
    var $el = $(this);
    var line = $el.data().line;
    if (line) {
      updateQuantity(line, 0);
    }
    cartUpsellSlider();
    carUpsellHandle();
  }

  function updateQuantity(line, qty) {
    isUpdating = true;
    // Add activity classes when changing cart quantities
    $cartContainer.addClass('is-updating');
    var $row = $cartContainer.find('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

    if (qty === 0) {
      $row.parent().addClass('is-removed');
    }

    // Slight delay to make sure removed animation is done
    setTimeout(function () {
      ShopifyAPI.changeItem(line, qty, adjustCartCallback);
    }, 100);
  }

  // Save note anytime it's changed
  $body.on('change', 'textarea[name="note"]', function () {
    var newNote = $(this).val();

    // Update the cart note in case they don't click update/checkout
    ShopifyAPI.updateCartNote(newNote, function (cart) { });
  });
};

adjustCartCallback = function (cart) {
  if (cart.item_count === previousCart.item_count) {
    $cartContainer.removeClass('is-updating');
    return;
  }
  isUpdating = false;
  // Update quantity and price
  //updateCountPrice(cart);
  // Reprint cart on short timeout so you don't see the content being removed
  setTimeout(function () {
    ShopifyAPI.getCart(buildCart);
  }, 150)
  setTimeout(function(){
    window.cartData();
  },400);
  updateNav(cart.item_count);
  updateShippingMessage(cart);
};

function updateNav(item_count) {
  const word = item_count>1? 'ITEMS':'ITEM';
  $('.cart-link__item-count').html(`${item_count}<span class="cart-link__item-count--word"> ${word} </span>`);
  if (item_count === 0) {
    $('.cart-link__item-count').hide();
  }
  else {
    $('.cart-link__item-count').show();
  }
}

function updateShippingMessage(cart) {
  var $shipping = $('.freeShippingMessage.free-shipping-message');
  var shippingAmount = $shipping.data()['freeShippingAmount'];
  var freeShippingMin = shippingAmount == ''? 12000:parseInt(shippingAmount);
  var amountTillFreeShip = freeShippingMin - cart.total_price;
  var amountTillFreeShipFormated = slate.Currency.formatMoney(amountTillFreeShip, settings.moneyFormat);
  if (amountTillFreeShip < 0) {
    $('.freeShippingMessage').html()
  }
  if (amountTillFreeShip > 0) {
    $('.freeShippingMessage11').html('<div class="free-shipping-message"><div>SPEND <strong>AU <span id="freeShippingAmount">'
    + amountTillFreeShipFormated + '</span></strong> MORE FOR <strong>FREE SHIPPING</strong></div><small><i>Free shipping is only available within Australia</i></small></div>');
  }
  if (amountTillFreeShip === freeShippingMin || cart.total_price > freeShippingMin) {
    $('.freeShippingMessage1').html('FREE SHIPPING<br/><small><i>Free shipping is only available within Australia</i></small>');
    //$('.freeShippingMessage1').html('<div class="free-shipping-message"><div>FREE SHIPPING</div><small><i>Free shipping is only available within Australia</i></small></div>');
  }
}

createQtySelectors = function () {
  // If there is a normal quantity number field in the ajax cart, replace it with our version

  if ($('input[type="number"]', $cartContainer).length) {
    $('input[type="number"]', $cartContainer).each(function () {
      var $el = $(this),
        currentQty = $el.val();

      var itemAdd = currentQty + 1,
        itemMinus = currentQty - 1,
        itemQty = currentQty;

      var source = $("#JsQty").html(),
        template = Handlebars.compile(source),
        data = {
          id: $el.data('id'),
          itemQty: itemQty,
          itemAdd: itemAdd,
          itemMinus: itemMinus
        };

      // Append new quantity selector then remove original
      $el.after(template(data)).remove();
    });
  }
};

qtySelectors = function () {
  // Change number inputs to JS ones, similar to ajax cart but without API integration.
  // Make sure to add the existing name and id to the new input element
  var numInputs = $('input[type="number"]');

  if (numInputs.length) {
    numInputs.each(function () {

      var $el = $(this),
        currentQty = $el.val(),
        inputName = $el.attr('name'),
        inputId = $el.attr('id');

      var itemAdd = currentQty + 1,
        itemMinus = currentQty - 1,
        itemQty = currentQty;

      var source = $("#JsQty").html(),
        template = Handlebars.compile(source),
        data = {
          id: $el.data('id'),
          itemQty: itemQty,
          itemAdd: itemAdd,
          itemMinus: itemMinus,
          inputName: inputName,
          inputId: inputId
        };

      // Append new quantity selector then remove original
      $el.after(template(data)).remove();
    });

    // Setup listeners to add/subtract from the input
    $body.off('click', '.js-qty__adjust');
    $body.on('click', '.js-qty__adjust', function () {
      var $el = $(this),
        id = $el.data('id'),
        $qtySelector = $el.siblings('.js-qty__num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // Update the input's number
      $qtySelector.val(qty);

      // Trigger change
      $qtySelector.trigger('change');
    });
  }
};

validateQty = function (qty) {
  if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

module = {
  init: init,
  load: loadCart
};

return module;

}(ajaxCart || {}, jQuery));